import { PaymentElement } from '@stripe/react-stripe-js';

export const PaymentDetails = () => {
  // TODO: update placement of payment element

  // TODO: update styling of payment element

  // TODO: fix error
  // stripe.js:1 Uncaught (in promise) Error: Frame not initialized.
  //   at Fe.canMakePayment (stripe.js:1:706824)
  //   at d._canMakePaymentForBackingLibrary (stripe.js:1:739139)
  //   at stripe.js:1:741013
  //   at stripe.js:1:162507
  //   at async Promise.all (:3000/index 0)

  return (
    <div className="payment-details">
      <span className="body-text">Payment Details</span>
      <PaymentElement id="payment-element" />
      <br />
    </div>
  );
};
